import * as React from 'react';
import * as b_ from 'b_';
import { Trans } from 'react-i18next';
import { Link } from 'shared/components/Link';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import './styles.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('disabled-stock-notify');

const DisabledStockNotify: React.FC<Enhanced> = ({ t }) => (
  <div className={b()}>
    <div>{t('This share cannot be bought temporarily')}</div>
    <Trans i18nKey="Please pick another one">
      Please{' '}
      <Link to="/investments/stocks" className={b('link')}>
        pick another one
      </Link>
    </Trans>
  </div>
);

export default translate(DisabledStockNotify);
